import { useMemo } from 'react'
import Typography from '@mui/material/Typography'

import { getThresholds } from '@shared/service_types'
import type { TPetThresholdsProps } from './pet_search_simple.d'
import { useBookingContext } from '@providers/booking'

export const PetThresholds = ({ specieId }: TPetThresholdsProps) => {
  const bookingCtx = useBookingContext()
  const petCount = useMemo(
    () => getThresholds(bookingCtx.state.config?.booking?.petCount, specieId),
    [bookingCtx.state.config, specieId]
  )
  const totalWeight = useMemo(
    () => getThresholds(bookingCtx.state.config?.booking?.totalWeight, specieId),
    [bookingCtx.state.config, specieId]
  )
  const petWeight = useMemo(
    () => getThresholds(bookingCtx.state.config?.booking?.weight, specieId),
    [bookingCtx.state.config, specieId]
  )

  const legends = useMemo(() => {
    const rc = []
    if (petCount?.max) {
      rc.push(`max Pets ${Math.trunc(petCount?.max)}`)
    }
    if (petWeight?.max) {
      rc.push(`max pet weight ${Math.trunc(petWeight?.max)}`)
    }
    if (totalWeight?.max) {
      rc.push(`max room weight ${Math.trunc(totalWeight?.max)}`)
    }
    return rc
  }, [petCount?.max, petWeight?.max, totalWeight?.max])

  if (!specieId) {
    return null
  }

  if (legends.length === 0) {
    return null
  }

  return (
    <Typography variant="caption" component="span">
      ( {legends.join(', ')} )
    </Typography>
  )
}
